import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(1),
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
  error: {
    color: theme.palette.primary.error
  },
  warning: {
    color: theme.palette.primary.warning
  },
}));

export const AppCells = ({ apps, installedApps }) => {
  const classes = useStyles();
  let key = 0;

  var makeSubTitle = function (app) {
    let subtitle = '';
    if (installedApps) {
      let installedApp = installedApps[app.packageName];
      if (!installedApp) {
        subtitle = (
          <Typography variant="caption" display="block" gutterBottom noWrap className={classes.error}>
            {"Not Installed"}
          </Typography>
        )
      } else {
        let installedVersionCode = installedApp.versionCode;
        let installedVersionName = installedApp.versionName;
        let targetVersionCode = app.latestVersion || installedApp.versionCode;
        let targetVersionName = app.versionName || installedApp.versionName;
        let appIsOutdated = (installedVersionName !== targetVersionName || installedVersionCode !== targetVersionCode);
        subtitle = (
          <Typography variant="caption" display="block" gutterBottom noWrap className={appIsOutdated ? classes.warning : ''}>
            {"Installed: " + installedVersionCode}+{installedVersionName}
            <br />
            {appIsOutdated ? `Target: ${targetVersionCode}+${targetVersionName}` : ''}
          </Typography>
        )
      }
    } else {
      subtitle = (
        <Typography variant="caption" display="block" gutterBottom noWrap>
          {app.bundleName}
        </Typography>
      )
    }
    return subtitle
  }

  return (
    <Grid container spacing={1} className={classes.marginTop}>
      {apps.map(app => (
        <Grid item xs={2} key={key++}>
          <Paper className={classes.paper}>
            <img src={app.iconUrl} style={{ width: "100%" }} alt={app.title} />
            <Typography variant="subtitle2" gutterBottom noWrap>
              {app.title}
            </Typography>
            {makeSubTitle(app)}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
